import { GetDepositPromotionNamesForSelectorCouponResponse } from '@/modules/promotion/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { DepositPromotionQueryKeys } from '@/modules/promotion/keys'
import { getDepositPromotionNamesForSelectorCoupon } from '../../services'

export default function useQueryGetDepositPromotionNamesForSelectorCoupon(
	props?: UseBaseQueryOptions<GetDepositPromotionNamesForSelectorCouponResponse>,
) {
	return useQuery({
		queryKey: [
			DepositPromotionQueryKeys.GetDepositPromotionNamesForSelectorCoupon,
		],
		queryFn: () => getDepositPromotionNamesForSelectorCoupon(),
		...props,
	})
}
